<template>
<div>
    <el-dialog
        :title="$t('lang.loginModify')"
        :visible="visible"
        :width="width"
        @close="close"
    >
        <div class="form-container">
            <el-form ref="form" :model="formPassword">
                <el-form-item :label="$t('lang.OldPassword')">
                    <el-input v-model="formPassword.oldPassword" :placeholder="$t('lang.oldPassword')" show-password />
                </el-form-item>
                <el-form-item :label="$t('lang.NewPassword')">
                    <el-input v-model="formPassword.newPassword" :placeholder="$t('lang.newPassword')" show-password />
                </el-form-item>
                <el-form-item :label="$t('lang.ConfirmNewPassword')">
                    <el-input v-model="formPassword.password" :placeholder="$t('lang.againPassword')" show-password />
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t("lang.ReturnPage") }}</el-button>
            <el-button type="primary" @click="changePassword">{{ $t("lang.submit") }}</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
export default {
    name:'passwordModifyDialog',
    data(){
        return {
            visible:false,
            width:'480px',
            lang: "",
            userInfo:{},
            formPassword:{
                oldPassword:'',
                newPassword:'',
                password:'',
            },
            url:{
                edit:BASE_GLOB_API+'/user/edit',
            },
        }
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
    },
    methods:{
        changePassword(){
            if(!this.formPassword.oldPassword){
                this.$message.error(this.$t("lang.oldPassword"));
                return;
            }
            if(!this.formPassword.newPassword){
                this.$message.error(this.$t("lang.newPassword"));
                return;
            }
            if(!this.formPassword.password){
                this.$message.error(this.$t("lang.againPassword"));
                return;
            }
            if(this.formPassword.newPassword != this.formPassword.password){
                this.$message.error(this.$t("lang.PasswordText"));
                return;
            }
           
            let params = {
                account:this.userInfo.account,
                oldPassword:this.formPassword.oldPassword,
                password:this.formPassword.password,
            }
            axiosPost(this.url.edit, params).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.close()
                    this.$emit("ok");
                    this.formPassword.oldPassword ='';
                    this.formPassword.password ='';
                    this.formPassword.newPassword ='';
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        open(userInfo){
            this.userInfo = userInfo
            this.visible = true;
        },
        close(){
            this.visible = false;
        }
    }
}
</script>
<style lang="less" scoped>

</style>